<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>¿Quiénes eran los zuavos?</h2>
    <img @click="imageClicked(0)" src="galerias/gameRoom/FRANCESES.png" class="mainphoto"/>
    <p class="photo-description">
      Título: <b>Batalla del 5 de mayo de 1862 (detalle zuavos)</b><br>
      Autor: Patricio Ramos<br>
      Año: siglo XIX<br>
      Técnica: Óleo sobre tela.<br>
      Medidas: Alto: 146 cms. Ancho: 198 cms.<br>
      Colección: colección del Museo Regional Casa de Alfeñique
    </p>
    <p>Los países occidentales a principios del siglo XIX comenzaron su expansión colonial principalmente África y Asia. A la par de ganar territorio, ganaban personal procedente de esas regiones para sus ejércitos. Francia añadió a sus fuerzas armadas a soldados vietnamitas, marroquíes y senegaleses entre otros, destacando especialmente los argelinos, quienes integrarían las unidades de Zuavos, agrupaciones militares de élite.</p>
    <p>Bajo el mando de Napoleón III, los zuavos llegaron a México, como parte del ejército francés.  En mayo de 1862, fueron derrotados en la ciudad de Puebla y obligados a retirarse, a pesar de que durante el siglo XIX eran considerados como una de las potencias militares. </p>
    <p>Ver más: <a target="_blank" href="https://archivoshistoria.com/historia-de-las-unidades-de-zuavos-1830-1920/">archivoshistoria.com</a></p> 
  </div>
</template>

<script>
export default {
  name: "GameM3",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
